import { useRef } from 'react'
import { Box, CircularProgress } from '@material-ui/core'

import { useBoolean } from 'hooks'

type ImageWithLoadProps = {
    imageUrl: string
    minHeight?: number
    borderRadius?: number
    width?: string
}

export const ImageWithLoad = ({
    imageUrl,
    minHeight = 268,
    borderRadius = 0,
    width = '100%'
}: ImageWithLoadProps) => {
    const loaded = useBoolean()
    const ref = useRef<HTMLImageElement>(null)

    const handleError = () => {
        loaded.setTrue()
        if (ref.current) {
            ref.current.style.display = 'none'
        }
    }

    return (
        <>
            {loaded.isFalse && (
                <Box
                    width="100%"
                    height="100%"
                    minHeight={minHeight}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Box>
            )}
            <img
                ref={ref}
                src={imageUrl}
                width={width}
                draggable={false}
                onLoad={loaded.setTrue}
                onError={handleError}
                style={{
                    visibility: loaded.isTrue ? 'visible' : 'hidden',
                    borderRadius: `${borderRadius}px`,
                    maxWidth: '1080px',
                    objectFit: 'cover'
                }}
                loading="lazy"
                alt="preview"
            />
        </>
    )
}
